const DepartamentoHome = () =>
  import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/CadastroDepartamentosHome')

const CadastroDepartamento = () =>
  import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/CadastroDepartamento')

const AtualizarDepartamento = () =>
  import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/AtualizarDepartamento')

import { permissionsCadastroDepartamento } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'departamento',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroDepartamento] },
    component: DepartamentoHome,
    name: 'Departamento',
  },
  {
    path: 'departamento/criar',
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_CADASTRO_DEPARTAMENTO_TOTAL],
    },
    component: CadastroDepartamento,
    name: 'Departamento/criar',
  },
  {
    path: 'departamento/atualizar/:_id',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroDepartamento] },
    component: AtualizarDepartamento,
    name: 'Departamento/atualizar',
    props: true,
  },
]
